import React from 'react';
import { ExactOnlineCustomerAccountsQueryProvider } from './ExactOnlineCustomerAccountsQueryProvider';

export const ExactOnlineCustomerAccountsProviders = ({ children }: any) => {
	return <ExactOnlineCustomerAccountsQueryProvider>{children}</ExactOnlineCustomerAccountsQueryProvider>;
};
